<div class="example-container mat-elevation-z8">


  <div class="example-table-container">

    <table mat-table [dataSource]="data" class="example-table" matSort (matSortChange)="onSortData($event)">



      <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{printCol(column)}} </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'td_width '+column">
          {{printElement(column,element)}}
          <mat-icon *ngIf="column == 'azioni' && showDettaglio" class="green" (click)="detail(element)"
            matTooltip="{{detailIconToolTip}}">search</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociaCompetenze" class="green"
            (click)="associaCompetenze(element)" matTooltip="Associa competenze">menu</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociaConoscenze" class="green"
            (click)="associaConoscenze(element)" matTooltip="Associa conoscenze">dialpad</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociaClassificazioni && checkException(element)" class="green"
            (click)="associaClassificazioni(element)" matTooltip="Associa classificazioni">queue</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showAssociaAbilita" class="green"
            (click)="associaAbilita(element)" matTooltip="Associa abilità">assignment </mat-icon>

          <!-- assemblea icone -->


          <mat-icon *ngIf="column == 'azioni' && showAssociazioniProfiliAssemblea && element.stato.id != 1" class="green"
            (click)="associazioneProfiliAssemblea(element)" matTooltip="Mostra associazioni profili">dialpad</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociazioniCompetenzeAssemblea && element.stato.id != 1" class="green"
            (click)="associazioneCompetenzeAssemblea(element)"
            matTooltip="Mostra associazioni competenze">menu</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && editAssociazioniProfiliAssemblea && element.stato.id == 1" class="green"
            (click)="editAssociazioneProfiliAssemblea(element)" matTooltip="Associa profili professionali">dialpad</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && editAssociazioniCompetenzeAssemblea && element.stato.id == 1" class="green"
            (click)="editAssociazioneCompetenzeAssemblea(element)"
            matTooltip="Associa competenze">menu</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showEliminaAssemblea && element.stato.id == 1" (click)="eliminaAssemblea(element)"
            matTooltip="Elimina" class="green">delete</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showApprovaContenuti && element.stato.id == 1" (click)="approvaContenuti(element)"
            matTooltip="Approva i contenuti dell'assemblea" class="green">lock</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showDecreta && element.stato.id == 2" class="green"
            (click)="decretaAssemblea(element)" matTooltip="Decreta Assemblea" class="green">library_books</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showDecreta && element.stato.id == 2" class="green"
            (click)="pubblicaAssemblea(element)" matTooltip="Decreta e pubblica assemblea" class="green">check</mat-icon>



          <!-- fine assemblea icone -->

          <mat-icon *ngIf="column == 'azioni' && modificaPropostaCompetenza && element.modificaCompetenza" class="green"
            (click)="modificaCompetenza(element)" matTooltip="Modifica proposta competenza">edit</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && validaCompetenza && element.modificaCompetenza" class="green"
            (click)="validazioneCompetenza(element)" matTooltip="Valida proposta competenza">check</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && validaCompetenza && element.modificaCompetenza" class="green"
            (click)="rifiutaCompetenza(element)" matTooltip="Rifiuta proposta competenza">cancel</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && modificaProfiloProfessionale && element.statoProposta.id != 5"
            class="green" (click)="detailProfilo(element)"
            matTooltip="Modifica proposta profilo professionale">edit</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && validaProfilo && element.statoProposta.id != 5" class="green"
            (click)="validazioneProfilo(element)" matTooltip="Valida proposta profilo professionale">check</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && validaProfilo && element.statoProposta.id != 5" class="green"
            (click)="rifiutaProfilo(element)" matTooltip="Rifuta proposta profilo professionale">cancel</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showElimina" (click)="elimina(element)"
            matTooltip="Elimina" class="green">delete</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza && showDisabilitaUtente && (element.flagAttivo && element.flagAttivo != 'NO')"
            (click)="disabilitaUtente(element)" matTooltip="Disabilita Utente"
            class="icon-red">cancel</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza  && (element.flagAttivo && element.flagAttivo == 'NO')"
            (click)="abilitaUtente(element)" matTooltip="Abilita Utente"
            class="green">check_circle</mat-icon>


          <mat-icon
            *ngIf="column == 'azioni' && showAbilitaOperatore && (element.flagAttivo && element.flagAttivo == 'NO')"
            class="green" (click)="abilitaOperatore(element)" matTooltip="Abilita operatore">check</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && showDisabilitaOperatore && (element.flagAttivo && element.flagAttivo == 'SI')"
            class="green" (click)="disabilitaOperatore(element)" matTooltip="Disabilita operatore">cancel</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showArchivioProposte && element.statoProposta.id == 7" class="green"
            (click)="duplicaProfilo(element)" matTooltip="Duplica profilo">file_copy</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza && showArchivioCompetenze && (element.tipologia.id == 1 && element.stato.id == 7)"
            class="green" (click)="archiviaCompetenza(element)" matTooltip="Archivia competenza">archive</mat-icon>
          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showArchivioProposte && element.statoProposta.id == 7" class="green"
            (click)="archiviaProposta(element)" matTooltip="Archivia proposta">archive</mat-icon>


            <mat-icon *ngIf="column == 'azioni' && showAbilitaConoscenze" class="green" (click)="detailAbilitaConoscenza(element)"
            matTooltip="Visualizza dettaglio">search</mat-icon>




          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showInvia" matTooltip="Invia ad un tecnico"
            (click)="invia(element)" class="green">send</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && showCaricaDocumenti" matTooltip="Sostituisci documento"
            (click)="sostituisciDoc(element)" class="green">find_replace</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && showCaricaDocumenti" matTooltip="Elimina documento"
            (click)="eliminaDoc(element)" class="green">cancel</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && showCaricaDocumenti" matTooltip="Scarica PDF documento"
            (click)="scaricaDocPdf(element)" class="green">file_copy</mat-icon>


        </td>

      </ng-container>




      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
    </table>
  </div>

  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100]" [length]="paginatorSize" [pageIndex]="pageIndex"
    (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>

  <!-- <mat-paginator [length]="paginatorSize" [pageSize]="10" aria-label="Seleziona pagina"
    showFirstLastButtons  (page)="pageEvent = $event; onPaginateChange($event)"></mat-paginator> -->
</div>
